import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'save',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-save wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.5 3a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5V6.582a.5.5 0 0 0-.146-.353l-3.083-3.083q0 0 0 0A.5.5 0 0 0 17.418 3zM9 5h6v2H9zm8 3.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V5H5v14h2v-6.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V19h2V7.203l-2-2zM9 19h6v-5H9z" class="wd-icon-fill" clip-rule="evenodd"/></svg>',
    filename: 'wd-icon-save.svg',
    category: 'Editor',
    tags: ['save', 'planning'],
};
export default icon;
